import axiosInstance from '../axiosInstance';

const fileUploadRequest = async (url, fileList = [], extra = {}, file = {}) => {
  let headers = {
    'content-type': 'multipart/form-data',
  };

  const token = localStorage.getItem('uls_access_token');

  if (token) {
    headers = { ...headers, Authorization: `Bearer ${token}` };
  }

  const formData = new FormData();

  if (fileList.length > 0) {
    fileList.forEach((file) => {
      formData.append('file', file);
      formData.append('isPublic', true);
    });
  } else {
    formData.append('file', file);
  }

  Object.keys(extra).forEach((key) => {
    formData.append(key, extra[key]);
  });

  return axiosInstance.post(url, formData, { headers });
};

export default fileUploadRequest;
